<template>
    <div class="std-margin-btm-1 card">
        <v-layout align-end justify-space-between flex-vertical-center breadcrumbs-div>
            <div class="inline-block">
                <div class="inline-block"><i class="fas fa-arrow-left square-btn back-sqr-Btn" @click="backPrevious()" /></div>
                <div class="inline-block">
                    <!-- Programme, Crossing Programme, Crossing, Progeny -->
                    <p v-if="programId" class="breadcrumbsLink" @click="routerTo('/programme/programme-detail/'+programId)">Programme ({{ programInfo.code }})</p>

                    <span v-if="crossingProgramId"> &nbsp;/&nbsp; </span>
                    <p v-if="crossingProgramId" class="breadcrumbsLink" @click="routerTo('/crossing-programme/crossing-programme-detail/'+crossingProgramId)">Crossing Programme ({{ crossingProgramInfo.externalCode }})</p>

                    <span v-if="crossingId"> &nbsp;/&nbsp; </span>
                    <p v-if="crossingId" class="breadcrumbsLink" @click="routerTo('/crossing/crossing-detail/'+crossingId)">Crossing ({{ crossingInfo.externalCode }})</p>

                    <div v-if="progenyId" class="inline-block">
                        <span v-if="programId" class="breadcrumbsNoData"><span> &nbsp;/&nbsp; </span></span>
                        <p v-if="progenyId" class="breadcrumbsLink">Progeny ({{ progenyInfo.code }})</p>
                    </div>

                    <!-- Trial Detail -->
                    <p v-if="TrialId" class="breadcrumbsLink">Trial ({{ TrialInfo.trialNumber }})</p>

                    <!-- Agency Detail -->
                    <p v-if="AgencyId" class="breadcrumbsLink">Agency ({{ AgencyInfo.name }})</p>

                    <!-- Germplasm Detail -->
                    <p v-if="GermplasmId" class="breadcrumbsLink">Germplasm ({{ GermplasmInfo.accessionNumber }})</p>
					
                    <!-- Palm Detail-->
                    <div v-if="PalmId" class="inline-block">
                        <p v-if="palmProgramId" class="breadcrumbsLink" @click="routerTo('/programme/programme-detail/'+palmProgramId)">Programme ({{ PalmProgramInfo.code }})</p>
                        <span v-if="!palmProgramId" class="breadcrumbsNoData">No Programme</span>
                        <span> &nbsp;/&nbsp; </span>

                        <p v-if="ProgenyId" class="breadcrumbsLink" @click="routerTo('/progeny/progeny-detail/'+ProgenyId)">Progeny ({{ ProgenyInfo.code || '-' }})</p>
                        <span v-if="!ProgenyId" class="breadcrumbsNoData">No Progeny</span>
                        <span> &nbsp;/&nbsp; </span>


                        <p v-if="PalmId" class="breadcrumbsLink">Palm ({{ PalmInfo.trialPalmNumber }})</p>
                    </div>

                    <slot name="page-title" />
                </div>
            </div>

            <div>
                <slot name="extra-button-area" />
            </div>
            <!-- 		  <div>
		  	<div class="inline-block"><i class="fas fa-angle-left square-btn"></i></div>
		  	<div class="inline-block"><i class="fas fa-angle-right square-btn"></i></div>
		  </div> -->
        </v-layout>
    </div>
</template>

<script>
export default {
    props: ["programId", "crossingProgramId", "crossingId", "progenyId", "ProgenyId", "PalmId", "TrialId", "AgencyId", "GermplasmId", "palmProgramId"],
    data () {
        return {
            msg: "BackBtn",

            programInfo: "",
            crossingProgramInfo: "",
            crossingInfo: "",
            progenyInfo: "",

            ProgenyInfo: "",
            PalmInfo: "",
            PalmProgramInfo: "",
            TrialInfo: "",

            AgencyInfo: "",
            GermplasmInfo: "",
        };
    },
    watch: {
        programId() {
            this.callAPI("Program/Get", this.programId, "programInfo");
        },
        crossingProgramId() {
            this.callAPI("CrossingProgram/Get", this.crossingProgramId, "crossingProgramInfo");
        },
        crossingId() {
            this.callAPI("Crossing/Get", this.crossingId, "crossingInfo");
        },
        progenyId() {
            this.callAPI("Progeny/Get", this.progenyId, "progenyInfo");
        },
        ProgenyId() {
            if (this.ProgenyId) this.callAPI("Progeny/Get", this.ProgenyId, "ProgenyInfo");
        },
        PalmId() {
            this.callAPI("Palm/Get", this.PalmId, "PalmInfo");
        },
        TrialId() {
            this.callAPI("Trial/Get", this.TrialId, "TrialInfo");
        },
        AgencyId() {
            this.callAPI("Agency/Get", this.AgencyId, "AgencyInfo");
        },
        GermplasmId() {
            this.callAPI("Germplasm/Get", this.GermplasmId, "GermplasmInfo");
        },
        palmProgramId() {
            this.callAPI("Program/Get", this.palmProgramId, "PalmProgramInfo");
        },
    },
    methods: {
        backPrevious() {
            this.$router.go(-1);
        },
        routerTo(link) {
            this.$router.push(link);
        },
        callAPI(url, id, responseName) {
            var self = this;
            axios({
				  method: "GET",
				  url: url,
				  params: {
				    Id: id
				  }
            })
                .then(function (response) {
                    self[responseName] = response.data.result;
                });
        }
    }
};
</script>
<style scoped>
.backBtnText{
	font-weight: 600;
	margin: 0;
}
.back-sqr-Btn{
	width: 50px;
	margin-right: 10px;
}
.breadcrumbsDiv{
	background-color: #fff;
}
.breadcrumbsNoData{
	margin: 0;
	display: inline-block;
	font-size: 15px;
	font-weight: 600;
	color: #616161;
	line-height: 20px;
}
.breadcrumbsLink{
	margin: 0;
	display: inline-block;
	font-size: 15px;
	font-weight: 600;
	color: #0091EA;
	line-height: 20px;
}
.breadcrumbsLink:last-child {
	margin: 0;
	display: inline-block;
	font-size: 15px;
	font-weight: 600;
	color: #616161;
	line-height: 20px;
}
.breadcrumbsLink:hover{
	border-bottom: 1px solid #0091EA;
	cursor: pointer;
}
.breadcrumbsLink:last-child:hover {
  border-bottom: none;
  cursor: default;
}
</style>


// WEBPACK FOOTER //
// src/smallComponents/backBtn.vue